import React from 'react';
import { Box, Loader } from '@wix/design-system';
export const CenteredLoader = _ref => {
  let {
    size
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    verticalAlign: "middle",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: size
  }));
};
//# sourceMappingURL=CenteredLoader.js.map